import type { WordpressFAQItem } from "@gik/core/models/wordpress/WordpressFAQItem";
import type { FAQPageLDSchema } from "@gik/seo";
import { stripHtml } from "string-strip-html";

export default function faqSDGenerator(
	faqItems: WordpressFAQItem[],
): FAQPageLDSchema {
	if (!faqItems?.length) {
		return null;
	}

	return {
		"@type": "FAQPage",
		name: "Common Questions",
		url: "https://www.giveinkind.com/faq",
		mainEntity: faqItems.map((faqItem) => ({
			"@type": "Question",
			name: stripHtml(faqItem.question).result,
			acceptedAnswer: {
				"@type": "Answer",
				text: stripHtml(faqItem.answer).result,
			},
		})),
	};
}
